export interface ApiError {
    message: string;
  }
  
  export interface ApiResult<T> {
    data?: T;
    error?: ApiError;
  }

  export function isSuccess<T>(res: ApiResult<T>): res is { data: T } {
    return !!res.data;
  }
  